export default __webpack_public_path__ + "static/media/sentiment-mixed.bbc5db4e.svg";